<script setup lang="ts">
import { onMounted } from 'vue';
import ToastContainer from '@/components/notifications/ToastContainer.vue';
import RoleRequestModal from '@/components/RoleRequestModal.vue';
import { useLocale } from '@/composables/useLocale';

const { ensureDefaultLocale } = useLocale();

onMounted(() => {
  ensureDefaultLocale();
});
</script>

<template>
  <RouterView />
  <RoleRequestModal />
  <ToastContainer />
</template>
